import { Mesh, Object3D, Shape, ShapeGeometry } from "three";
import { Jaco } from "oc-jaco3d/arrangement/Jaco";
import { Jaco3d } from "oc-jaco3d/arrangement3d/Jaco3d";
import * as Scenes from "oc-threejs/Scenes";
import * as Maths3 from "oc-threejs/Maths3";
import { v2 } from "oc-threejs/short3";
import { Grundriss } from "../arrangement/Grundriss";

export class Grundriss3d extends Jaco3d {
  CLASS_NAME = "Grundriss3d";
  declare jaco: Grundriss;

  mesh: Object3D;

  constructor(jaco: Jaco) {
    super();
    this.jaco = jaco as Grundriss;
    this.name = this.CLASS_NAME;
  }

  update3d() {
    if (
      this.changed("convexHull", (j) => (j as Grundriss).ecken.map(({ punkt }) => punkt)) ||
      this.changed("daynightMaterial", () => APP.nightMode)
    ) {
      Scenes.remove(this.mesh);
      const hull = this.jaco.convexHull.map((p) => v2(p.punkt.x, -p.punkt.y));
      if (hull.length > 0) {
        const shape = new Shape(hull);
        const geometry = new ShapeGeometry(shape);
        const mesh = new Mesh(
          geometry,
          APP.nightMode
            ? APP.materials.create("grundrissShapeNight")
            : APP.materials.create("grundrissShape")
        );
        mesh.renderOrder = 9000;
        this.add(mesh);
        this.mesh = mesh;
      }
    }
    this.quaternion.copy(Maths3.quaternion.x270);
  }
}
